export default {
  initialized: false,
  items: [],
  item: {},
  closing_codes: [],
  closing_reasons: [],
  closing_date: ""
};
